//@ts-ignore
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "RadioGroup",
  components: {
    RadioButton: RadioButton
  },
  inheritAttrs: false,
  props: {
    initialValue: {
      type: Object
    },
    radioValues: {
      type: Array
    },
    resetRadio: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["resetted", "update:modelValue"],
  data: function data() {
    return {
      selectedValue: null
    };
  },
  watch: {
    resetRadio: function resetRadio(cur, prev) {
      if (cur) {
        this.reset();
        this.$emit("resetted");
      }
    }
  },
  created: function created() {
    this.initialValue && this.handleChange(this.initialValue);
  },
  methods: {
    handleChange: function handleChange(elem) {
      this.selectedValue = elem;
      this.$emit("update:modelValue", elem);
    },
    reset: function reset() {
      this.selectedValue = null;
    },
    isActive: function isActive(elem) {
      if (!this.selectedValue) return false;
      return this.selectedValue.id === elem.id;
    }
  }
});